<template>
  <div class="site-wrapper site-page--login">
    <div class="site-content__wrapper">
      <div class="site-content">
        <div class="brand-info">
          <img alt="点点灵工" class="brand-info__box" src="/login-box-bg.svg">
          <h2 class="brand-info__text">点点灵工后台管理系统</h2>
          <p class="brand-info__intro">欢迎使用本平台</p>
        </div>
        <div class="login-main">
          <div class="text-center">
            <a-tabs v-model='activeKey' @change="changeTab" size="large" :tabBarGutter="80">
              <a-tab-pane key="1" tab="账号登录">
              </a-tab-pane>
              <a-tab-pane key="2" tab="手机验证码登录" v-if="smsLoginEnabled">
              </a-tab-pane>
            </a-tabs>
          </div>
          <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
            <div v-if="activeKey === '1'">
              <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" :message="loginErrorInfo"
                closable :after-close="handleCloseLoginError" />
              <a-form-model-item prop="accountNo">
                <a-input v-model="form.accountNo" size="large" placeholder="请输入账户">
                  <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input-password v-model="form.password" size="large" placeholder="请输入密码">
                  <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item prop="rememberMe" class="text-left">
                <div>
                  <a-checkbox :checked="form.rememberMe" @change="rememberMe">记住密码</a-checkbox>
                </div>
              </a-form-model-item>
              <a-form-model-item style="margin-top:24px">
                <!--开启图形验证码-->
                <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
                          :disabled="logining" @click="userLoginVerify" v-if="captchaEnabled && activeKey == 1">确定</a-button>
                <!--未开启图形验证码-->
                <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
                          :disabled="logining" @click="handleSubmit" v-if="!captchaEnabled">确定</a-button>
              </a-form-model-item>
            </div>
            <a-row v-if="activeKey === '2'">
              <a-form-model-item prop="mobile">
                <a-input v-model="form.mobile" size="large" placeholder="手机号" :maxLength="11">
                  <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input>
              </a-form-model-item>
              <div v-if="smsLoginEnabled">
                <a-form-model-item prop="code">
                  <div style="position: relative;">
                    <a-input v-model="form.code" size="large" type="text" autocomplete="off" placeholder="验证码"
                      :maxLength="6">
                      <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
                    </a-input>
                    <span class="codeText">
                      <span v-if="mobileCodeTimer <= 0" @click="smsCodeVerify">
                        获取验证码
                      </span>
                      <a-spin v-if="codeLoading" size="small">
                        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                      </a-spin>
                      <span v-if="mobileCodeTimer > 0">
                        {{ mobileCodeTimer }}秒后可重新获取
                      </span>
                    </span>
                  </div>
                </a-form-model-item>
                <a-form-model-item style="margin-top:24px">
                  <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
                            :disabled="logining" @click="handleSubmit">登录</a-button>
                </a-form-model-item>
              </div>
            </a-row>

            <div class="user-login-other">

              <div style="position: absolute;left: 0;top: 10px;" v-if="captchaEnabled || smsLoginEnabled">
                <Verify
                    ref="verify"
                    mode="pop"
                    @success="success"
                    :captchaType="'blockPuzzle'"
                    :imgSize="{ width: '330px', height: '155px' }"
                ></Verify>
              </div>
            </div>
          </a-form-model>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getSmsCode, getCodeImg, getLoginConfig } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import Verify from '@/components/verifition/Verify.vue'
import storage from 'store'

export default {
  components: {
    Verify
  },
  ...mapActions(['Login', 'SmsLogin', 'Logout']),
  data() {
    return {
      loginBoxBg: require('@/assets/login-box-bg.svg'),
      activeKey: '1',
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      mobileCodeTimer: 0,
      codeText: '获取验证码',
      codeLoading: false,
      form: {
        accountNo: '',
        password: '',
        mobile: '',
        code: undefined,
        validCodeReqNo: '',
        uuid: '',
        rememberMe: false
      },
      rules: {},
      rule1: {
        username: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      rule3: {
        code: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
      },
      rule2: {
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, {
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: '请正确填写手机号',
          trigger: 'blur'
        }],
      },
      logining: false,
      captchaEnabled: false,
      smsLoginEnabled: false,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    },
    // activeKey: {
    //   handler: function (newVal) {
    //     if (newVal) {
    //       this.$refs.form.resetFields()
    //       this.logining = false
    //       if (newVal === '1') {
    //         this.rules = this.rule1
    //         this.form.username = "";
    //         this.form.password = "";
    //       } else if (newVal === '2') {
    //         this.form.code = "";
    //         this.form.mobile = "";
    //         this.rules = this.rule2
    //       }
    //     }
    //   },
    //   immediate: true
    // }
  },
  created() {
    this.getStorage()
    this.rules = this.rule1
    this.getConfig()
  },
  methods: {
    /**
     * 滑块验证插件
     */
    success(params) {
      this.form.captchaVerification = params.captchaVerification
      if(this.activeKey == 1) {
        this.handleSubmit()
      }else if(this.activeKey == 2) {
        this.getSmsCode()
      }
    },
    // 点击显示滑块验证弹窗
    userLoginVerify() {
      this.$refs.verify.show()
    },
    // 点击显示滑块验证弹窗
    smsCodeVerify() {
      //校验手机号
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$refs.verify.show()
        }
      });
    },
    changeTab() {
      if (this.activeKey === '1') {
        this.rules = this.rule1
      } else if (this.activeKey === '2') {
        this.rules = this.rule2
      }
    },
    /**—————————————————————————— 获取配置项，验证码和图形验证码是否开启 start ——————————————————————————*/
    getConfig() {
      getLoginConfig().then(res => {
        this.captchaEnabled = res.data.captchaEnabled
        this.smsLoginEnabled = res.data.smsLoginEnabled
      })
    },
    /**—————————————————————————— 获取配置项，验证码和图形验证码是否开启 end   ——————————————————————————*/


    /** —————————————————————————— 发送短信验证码 start —————————————————————————— **/
    getSmsCode() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.mobileCodeTimer > 0) return;
          this.codeLoading = true
          getSmsCode({
            mobile: this.form.mobile,
            templateCode: 'MOBILE_LOGIN',
            captchaVerification: this.form.captchaVerification
          }).then(res => {
            this.codeLoading = false
            if (res.success) {
              this.mobileCodeTimer = 60;
              this.form.validCodeReqNo = res.data
              let msgTimer = setInterval(() => {
                this.mobileCodeTimer = this.mobileCodeTimer - 1;
                if (this.mobileCodeTimer <= 0) {
                  clearInterval(msgTimer);
                }
              }, 1000);
            } else {
              this.$message.error(res.message)
            }
          }).catch(() => {
            setTimeout(() => {
              this.codeLoading = false
            }, 5000)
          })
        }
      });
    },
    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    handleSubmit() {
      this.logining = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          let loginApi = ''
          if (this.activeKey === '1') {
            loginApi = 'Login'
          } else if (this.activeKey === '2') {
            if (this.smsLoginEnabled) {
              loginApi = 'SmsLogin'
            }
          }
          console.log(this.form)
          this.$store.dispatch(loginApi, this.form).then((res) => {
            this.$router.push({ path: this.redirect || '/' }).catch(() => { })
          }).catch((err) => {
            this.loading = false
            setTimeout(() => {
              this.logining = false
            }, 1000)
          })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    },
    onChange() { },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
  }
}
</script>

<style lang="less">
  .site-wrapper.site-page--login {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    overflow: hidden;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin-left: -48%;
      content: "";
      background-image: url(~@/assets/login_bg.svg);
      background-repeat: no-repeat;
      background-position: 100%;
      background-size: auto 100%;
    }
    .site-content__wrapper {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      padding: 0;
      margin: 0;
      overflow: hidden;
      background-color: transparent;
    }
    .site-content {
      min-height: 100%;
      padding: 30px;
      overflow: hidden;
    }
    .brand-info {
      margin: 220px 0 0 150px;
      color: #fff;
    }
    .brand-info__box {
      display: block;
      width: 30%;
      max-width: 320px;
      height: auto;
    }
    .brand-info__text {
      margin: 50px 0 22px 0;
      font-size: 40px;
      font-weight: 400;
    }
    .brand-info__intro {
      margin: 10px 0;
      font-size: 16px;
      line-height: 1.58;
      opacity: .6;
    }
    .login-main {
      position: absolute;
      top: 0;
      right: 180px;
      padding: 150px 60px 180px;
      width: 470px;
      min-height: 100%;
      background-color: #fff;
      overflow-y: auto;
    }
    .login-logo {
      text-align: center;
    }
    .login-title {
      font-size: 28px;
      margin-top: 40px;
    }
    .login-captcha {
      overflow: hidden;
      > img {
        width: 100%;
        cursor: pointer;
      }
    }
    .user-layout-login .login-button {
      width: 100%;
      margin-top: 38px;
      height: 40px;
      font-size: 16px;
    }
    .login-btn-submit {
      width: 100%;
      margin-top: 38px;
    }
  }
</style>
